import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DataGrid, Dialog, DialogContent, DialogTitle, Grid } from 'src/components'
import { useAppSelector } from 'src/store'
import { helper } from 'src/utils/helper'

interface IDuyuruOkumaDetay {
    mesajOku?: boolean;
    setMesajOku: (value: boolean) => void;
}

const DuyuruOkumaDetay = (props: IDuyuruOkumaDetay) => {
    const { t } = useTranslation();
    const rl = "pages|duyuru|duyuruOkumaDetay|"
    const mesajOkumaBilgisiDetay = useAppSelector(s => s.DuyuruTanimState.mesajOkumaBilgisiDetay)

    const handleBackClick = () => {
        props.setMesajOku(false);
    }

    return (
        <Dialog open={true} maxWidth='md'>
            <DialogTitle>
                {t(rl + 'okumaBilgiTitle', 'Okuma Bilgisi')}
            </DialogTitle>

            <DialogContent>
                <Grid container>

                    <Grid item>
                        <DataGrid
                            sx={{ height: '300px' }}
                            columns={[
                                {
                                    field: 'okumatarih',
                                    headerName: t(rl + 'okumaTarih', "Okuma Tarih"),
                                    type: 'dateTime',
                                    width: 150
                                },
                                {
                                    field: 'ipadres',
                                    headerName: t(rl + 'ipadres', 'IP'),
                                    type: 'string',
                                    width: 150
                                },
                                {
                                    field: 'makina',
                                    headerName: t(rl + 'makina', 'Makina'),
                                    type: 'string',
                                }
                            ]}
                            getRowId={(r) => r.id}
                            rows={mesajOkumaBilgisiDetay || []}
                        />
                    </Grid>

                    <Grid item md={8} lg={8} xl={8}></Grid>

                    <Grid item sm={12} md={4} lg={4} xl={4} >
                        <Button customType="close" onClick={handleBackClick} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default DuyuruOkumaDetay
